import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NegativeBanner } from 'next/components/ui';

// Note:
// This should export a connected `SpoofBanner` that gets
// The spoofed account id and the the cancel spoof function
// For now this is just a skeleton that will get those props
// from the old navbar

const CancelSpoof = styled.button`
  background: transparent;
  border: none;
  color: var(--white);
  font-size: var(--medium-large);
  font-weight: var(--bold);
  text-decoration: underline;

  &:hover {
    color: var(--nav-spoof-hover);
  }
`;

const Wrapper = styled(NegativeBanner)`
  font-size: var(--medium-large);
  height: 48px;
  left: var(--nav-width);
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 2000; /* To be on top of other elements in studio when scrolling */
`;

const SpoofBanner = ({ accountId, onCancel }) => {
  if (!accountId) {
    return null;
  }

  return (
    <Wrapper>
      Spoofing Account {accountId}{' '}
      <CancelSpoof onClick={onCancel}>Stop spoofing</CancelSpoof>
    </Wrapper>
  );
};

SpoofBanner.propTypes = {
  accountId: PropTypes.string,
  onCancel: PropTypes.func,
};

export default SpoofBanner;
